import { render } from "./TeamRegistration.vue?vue&type=template&id=6fffa872"
import script from "./TeamRegistration.vue?vue&type=script&lang=js"
export * from "./TeamRegistration.vue?vue&type=script&lang=js"

import "./TeamRegistration.vue?vue&type=style&index=0&id=6fffa872&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__